module.exports = __webpack_public_path__ + "assets/ic_down_arrow.6df67daf.svg";